export function convertFileSize(size) {
  const units = ['bytes', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];

  let l = 0; let
    n = parseInt(size, 10) || 0;

  // eslint-disable-next-line no-plusplus
  while (n >= 1024 && ++l) {
    n /= 1024;
  }

  return (`${n.toFixed(n < 10 && l > 0 ? 1 : 0)} ${units[l]}`);
}

export default convertFileSize;
